<template>
  <div class="indexPageBox">
    <div class="bannerBox">
      <HeaderCom></HeaderCom>
      <swiper ref="mySwiper" :options="swiperOptions" style="height: 580px">
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-01.png');">
            <div class="banner_item1_content">
              <p>智慧消防服务解决方案</p>
              <p class="txt1">智慧安全全产业链整合服务商，智慧安全一站式运营服务提供商, 带来全新消防体验</p>
              <div class="item1_infoBox">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-02.png');">
            <div class="banner_item1_content">
              <p>云现场远程检查服务系统</p>
              <p class="txt1">
                以双向音视频通话为技术手段，深化了“云端”+“服务”的理念，
                实行对企业的消防远程检查
              </p>
              <div class="item1_infoBox" @click="toCloud()">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-03.png');">
            <div class="banner_item1_content">
              <p>消防物联网解决方案</p>
              <p class="txt1">
                全市安装独立式烟感报警终端35,753台,分布全市养老院、
                独居老人、九小场所等
              </p>
              <div class="item1_infoBox">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner_item" style="background-image: url('static/image/banner-04.png');">
            <div class="banner_item1_content">
              <p>“双随机、一公开”消防监管信息系统</p>
              <p class="txt1">
                深化消防执法改革，创新监管方式，加强事中事后监管，
                规范执法行为，适应新的消防监督检查流程
              </p>
              <div class="item1_infoBox">
                立即申请
              </div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="sectionBox">
      <div class="sectionBox_content">
        <div  class="itemBox">
          <div class="itemBox_content" style="background-image: url('static/image/cloudscene.png');" @click="toCloud()">
            <p class="sectionBox_txt1">云现场远程检查服务系统</p>
            <p class="sectionBox_txt2">效率·环保·实用</p>
          </div>
          <div class="itemBox_content" @click="toDoubleRandom" style="background-image: url('static/image/doublerandom.png');">
            <p class="sectionBox_txt1">双随机一公开</p>
            <p class="sectionBox_txt2">公正·透明·科学</p>
          </div>
          <div class="itemBox_content" style="background-image: url('static/image/xiaoguantong.png');" @click="toPipeEliminator()">
            <p class="sectionBox_txt1">单位自主管理平台(消管通)</p>
            <p class="sectionBox_txt2">便捷·安全·高效</p>
          </div>
          <div class="itemBox_content" style="background-image: url('static/image/fireprevention.png');" @click="toFirePrevention()">
            <p class="sectionBox_txt1">防火指挥调度系统</p>
            <p class="sectionBox_txt2">智能·效率·预警</p>
          </div>
        </div>
      </div>
    </div>
    <div class="productsBox">
      <div class="productsBox_content">
        <div class="productsBox_content_header">
          <div>
            <img src="static/image/blueleft.png" alt="">
            <span class="productsBoxTxt">智慧产品</span>
            <img src="static/image/blueright.png" alt="">
          </div>
          <span class="productsBox_content_txt">提供适用各类消防场景的智慧平台</span>
        </div>
        <div class="productsBox_content_section">
          <div class="productsBox_section_item1" v-for="(item,index) in productList" @click="toProudcutInfo(item.title)" :key="" @mouseover="addActive($event,index)" @mouseleave="removeActive($event,index)">
            <img class="productsBox_section_img" :src=item.image alt="">
            <span class="productsBox_section_txt1">{{item.title}}</span>
            <div :class="{'item_line':item.isShowActive}"></div>
            <div class="productsBox_section_txt2">
              {{item.txt}}
            </div>
            <div class="infoBtn" v-show="item.isShowBtn == true">
              <div>
                查看详情
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solutionBox" style="background-image: url('static/image/bg.png');">
      <div class="solutionBox_content">
        <div class="solutionBox_menuBox">
          <ul class="menuBox">
            <li class="menuBox_item menuBox_itemActive" @click="changeMenu(1)">
              <div class="menu_line menu_lineActive"></div>
              <img src="static/image/impotentcompany.png" alt="">
              <span>重点单位</span>
            </li>
            <li class="menuBox_item" @click="changeMenu(2)">
              <div class="menu_line"></div>
              <img src="static/image/Highbuilding.png" alt="">
              <span>高层建筑</span>
            </li>
            <li class="menuBox_item" @click="changeMenu(3)">
              <div class="menu_line"></div>
              <img src="static/image/firechief.png" alt="">
              <span>消防主管部门</span>
            </li>
            <li class="menuBox_item" @click="changeMenu(4)">
              <div class="menu_line"></div>
              <img src="static/image/Personalsafety.png" alt="">
              <span>个人家庭安全</span>
            </li>
            <li class="menuBox_item" @click="changeMenu(5)">
              <div class="menu_line"></div>
              <img src="static/image/Smallplace.png" alt="">
              <span>九小场所</span>
            </li>
          </ul>
        </div>
        <div class="solutionBox_right">
          <div class="solutionBox_right_header">
            <div>
              <img src="static/image/whiteleft.png" alt="">
              <span>解决方案</span>
              <img src="static/image/whiteright.png" alt="">
            </div>
            <span class="productsBox_content_txt">智慧安全全产业链整合服务商，智慧安全一站式运营服务提供商</span>
          </div>
          <div class="solutionBox_right_content">
            <p>云平台远程监督检查解决方案</p>
            <p>
              系统主要包括数据统计分析、检查记录管理、远程直播检查、现场取证、视频回拉备案、视频断点重续、监督执法检查信息录入、
              联合签名、GPS定位等主要功能；
            </p>
            <div class="btn_txt">
              了解详情
            </div>
          </div>
          <div class="sceneBox">
            <p>适用场景：</p>
            <div>
              <span>视频直播检查</span><span>|</span><span>执法视频取证</span>
            </div>
          </div>
          <div class="customer_case">
            <p>客户案例：</p>
            <div class="caseBox">
              <img src="static/image/transparent_xinbai.png" alt="">
              <img src="static/image/transparent_longhunew.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cooperationBox">
      <div>
        <div class="cooperationBox_header">
          <div>
            <img src="static/image/blueleft.png" alt="">
            <span>合作伙伴</span>
            <img src="static/image/blueright.png" alt="">
          </div>
          <span>联合优秀合作伙伴，打造全产业链的消防领军企业</span>
        </div>
        <div class="iconBox">
          <img src="static/image/Newhundred.png" alt="">
          <img src="static/image/Veolia.png" alt="">
          <img src="static/image/HUAWEI.png" alt="">
          <img src="static/image/NanjingMetro.png" alt="">
          <img src="static/image/CentralSouthGroup.png" alt="">
          <img src="static/image/HaikouAirport.png" alt="">
          <img src="static/image/ShenzhenMetro.png" alt="">
          <img src="static/image/Longhu.png" alt="">
          <img src="static/image/HefeiOrbit.png" alt="">
        </div>
      </div>
    </div>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
    export default {
        name: "indexPage",
      components: {
        HeaderCom,
        FooterCom
      },
      data(){
         return{
           showTop:false,
           menuActive:"1",
           swiperOptions: {
             pagination: {
               el: '.swiper-pagination',
               clickable: true
             },
             // slidesPerView: 'auto',
             centeredSlides: true,
             autoplay: {
               delay: 2500,
               disableOnInteraction: false
             },
             height:580,
             loop:true,
             observer:true, //修改swiper自己或子元素时，自动初始化swiper
             observeParents:true,//修改swiper的父元素时，自动初始化swiper
             // Some Swiper option/callback...
           },
           isActive:'',
           productList:[{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/pipegallery.png",
             title:"公共管廊智慧管理系统",
             txt:"通过移动互联网、物联网、移动定位和二维码等技术，通过“四定”原则——定时间、定地点、定人员和定内容，解决管廊维护管理中的管廊台账、管线信息、巡线…",
           },{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/mobilefirefighting.png",
             title:"移动消防勤务系统",
             txt:"移动消防警务平台配合智能消防车，实现九小场所的信息采集、水源采集、安全巡查、教育宣传、灭火救援的功能。在巡查场所张贴MIP巡查点绑定单位信息与巡查内容…",
           },{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/microscholars.png",
             title:"消防微士",
             txt:"实现线上申请、验收流程全面信息化，单位责任人通过手机端即可完成微型消防站线上申请流程，提高各级工作效率。配合POC手机重点单位与辖区中队定期消防演练、联勤…",
           },{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/safetyresponsibility.png",
             title:"企业安责通系统",
             txt:"通过建立企业安责通系统，整体解决集团公司及下属各单位安全生产和综合整治的各项工作的信息化管理和基础管理台账资料的电子化，并辅助基本的统计、报表分析功能…",
           },{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/maintenance.png",
             title:"消防维保工作平台",
             txt:"全面管辖维保单位相关人员日常维保工作开展情况，釆用“定人、定时、定点、定规范” 的原则以确保一线维保人员工作的真实性，并定期发送统一的维保记录报告。同时对维保…",
           },{
             isShowActive:true,
             isShowBtn:false,
             image:"static/image/internetofthings.png",
             title:"消防物联网平台",
             txt:"消防物联网的统一接入平台，实现所有消防物联报警信息的统一汇聚、报警联动处理（报警后电话、短信、微信分级推送、分组监控，统一维保）和与智慧消防大数据平台的对接…",
           },]
         }
      },
      computed: {
        swiper() {
          return this.$refs.mySwiper.$swiper
        }
      },
      mounted() {
        // window.onload = function(){
        //   // 注意这里使用的ES6语法
        //   setTimeout(() => window.scrollTo(0,0), 50); // 返回页面顶部
        // };
        console.log('Current Swiper instance object', this.swiper);
        this.swiper.slideTo(1, 1000, false);
      },
      methods:{
        changeMenu(index){
          let lineActive = document.getElementsByClassName("menu_line");
          let menuActive = document.getElementsByClassName("menuBox_item");
          for (let i = 0; i < lineActive.length; i++) {
            if(i == (index-1)){
              lineActive[i].className = "menu_line menu_lineActive"
              menuActive[i].className = "menuBox_item menuBox_itemActive";
            }else{
              lineActive[i].className = "menu_line"
              menuActive[i].className = "menuBox_item";
            }
          }
        },
        addActive(e,index){
          e.currentTarget.className = "productsBox_section_item1 productsBox_section_itemActive";
          this.productList[index].isShowActive = false;
          this.productList[index].isShowBtn = true;
        },
        removeActive(e,index){
          e.currentTarget.className = "productsBox_section_item1";
          this.productList[index].isShowActive = true;
          this.productList[index].isShowBtn = false;
        },
        toCloud(){
          window.open("https://xffww.com/admin/#/login")
        },
        toDoubleRandom(){
          this.$router.push({
            name: "DoubleRandom"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        //详情跳转
        toProudcutInfo(title){
          if(title == "公共管廊智慧管理系统"){
            this.$router.push({
              name: "TransportManage"
            }).catch(err => {

            })
          }else if(title == "移动消防勤务系统"){
            this.$router.push({
              name: "MobileFire"
            }).catch(err => {

            })
          }else if(title == "消防微士"){
            this.$router.push({
              name: "MicroFire"
            }).catch(err => {

            })
          }else if(title == "企业安责通系统"){
            this.$router.push({
              name: "SafetyResponsibility"
            }).catch(err => {

            })

          }else if(title == "消防物联网平台"){
            this.$router.push({
              name: "InternetControl"
            }).catch(err => {

            })
          }else{
            this.$message({
              message: '正在建设中......',
              type: 'warning'
            });
          }

        },
        toPipeEliminator(){
          this.$router.push({
            name: "PipeEliminator"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
        toFirePrevention(){
          this.$router.push({
            name: "FirePrevention"
          }).catch(err => {
            // console.log('输出报错', err)
          })
        },
      }
    }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  /**/
  .sectionBox{
    width: 100%;
    display: flex;
    justify-content: center;
    background:#f0f0f0;
  }
  .sectionBox_content{
    width: 1200px;
    box-sizing: border-box;
    position: relative;
  }
  .sectionBox_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:#ffffff;
    line-height:9px;
    box-sizing: border-box;
    padding: 5px 0;
  }
  .sectionBox_txt2{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(178,182,225,1);
    line-height:9px;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .itemBox{
    width: 1200px;
    height: 180px;
    background: #ffffff;
    border-radius: 10px;
    position: absolute;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 20px 10px 20px 10px;
    top: -60px;
    z-index: 99999;
  }
  .itemBox_content{
    width: 24%;
    height: 100%;
    box-sizing: border-box;
    margin: 0 5px;
    border-radius: 10px;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10px;
    cursor: pointer;
  }
  /*智慧产品*/
  .productsBox{
    width: 100%;
    background:rgba(240,240,240,1);
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding: 160px 0 80px 0;
  }
  .productsBox_content{
    width: 1200px;
    box-sizing: border-box;
  }
  .productsBox_content_header{
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .productsBox_content_txt{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    display: inline-block;
    padding: 10px 0 20px 0;
  }
  .productsBoxTxt{
    font-size:24px;
    font-family:PingFang SC;
    color:rgba(51,51,51,1);
    display: inline-block;
  }
  .productsBox_content_section{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .productsBox_section_item1{
    width:380px;
    height:430px;
    background:rgba(255,255,255,1);
    border-radius:5px;
    margin: 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #333333;
    box-sizing: border-box;
    padding: 0 30px;
    cursor: pointer;
  }
  .productsBox_section_itemActive{
    box-shadow: 3px 3px 10px rgba(0,0,0,0.1);
  }
  .productsBox_section_img{
    width: 93px;
    height: 114px;
  }
  .item_line{
    width:50px;
    height:2px;
    background:rgba(42,98,255,1);
    margin: 0 0 15px 0;
  }
  .productsBox_section_txt1{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(51,51,51,1);
    padding: 15px 0;
  }
  .productsBox_section_txt2{
    text-align: center;
    font-size:14px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(102,102,102,1);
  }
  .infoBtn{
    width: 100%;
    box-sizing: border-box;
    padding: 40px 0 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .infoBtn>div{
    width:200px;
    height:40px;
    background:rgba(42,98,255,1);
    border-radius:5px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /*解决方案*/
  .solutionBox{
    width: 100%;
    height: 665px;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
  }
  .solutionBox_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
  }
  .solutionBox_menuBox{
    width: 30%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .menuBox{
    width: 244px;
    list-style: none;
    background:linear-gradient(rgba(5,5,8,0),rgba(5,5,8,0.3),rgba(5,5,8,0));
    font-size: 18px;
    padding: 15px 0;
  }
  .menuBox_item{
    width: 100%;
    height: 70px;
    box-sizing: border-box;
    padding: 8px 0 8px 33px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
  }
  .menuBox_item>img{
    display: inline-block;
  }
  .menuBox_item>span{
    box-sizing: border-box;
    padding: 0 10px;
  }
  .menu_line{
    width: 2px;
    height: 70px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top:0;
  }
  .menuBox_itemActive{
    background: linear-gradient(to right,rgba(55,58,75,1),rgba(55,58,75,0));
  }
  .menuBox_item:hover{
    background: linear-gradient(to right,rgba(55,58,75,1),rgba(55,58,75,0));
  }
  .menu_lineActive{
    background: #2f65df;
  }
  .menuBox_item:hover .menu_line{
    background: #2f65df;
  }
  .solutionBox_right{
    flex: 1;
    box-sizing: border-box;
    padding: 20px  0  0  20px;
  }
  .solutionBox_right_header{
    width: 500px;
    box-sizing: border-box;
    padding: 30px 0 0 0;
    text-align: center;
    color: #fff;
  }
  .solutionBox_right_header>div>span{
    font-size: 24px;
  }
  .solutionBox_right_header>span{
    font-size: 16px;
  }
  .solutionBox_right_content{
    width: 100%;
    box-sizing: border-box;
    padding: 35px 0 0 0;
  }
  .solutionBox_right_content p:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .solutionBox_right_content p:nth-of-type(2){
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(191,201,226,1);
    line-height:24px;
    padding: 23px 0 27px 0;
  }
  .btn_txt{
    width: 140px;
    height: 44px;
    box-sizing: border-box;
    border: 1px solid #fff;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
  }
  .sceneBox{
    width: 100%;
    box-sizing: border-box;
    padding: 50px 0 30px 0;
  }
  .sceneBox>p:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .sceneBox>div{
    box-sizing: border-box;
    padding: 10px 0;
  }
  .sceneBox>div>span{
    font-size:14px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(191,201,226,1);
    line-height:24px;
  }
  .sceneBox>div>span:nth-of-type(2){
    padding: 0 15px;
  }
  .customer_case>p:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
  }
  .caseBox{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0 0 0;
  }
  .caseBox img:nth-of-type(1){

  }
  .caseBox img:nth-of-type(2){
    display: inline-block;
    /*width:194px;*/
    /*height:30px;*/
    margin-left: 73px;
  }
  .cooperationBox{
    width: 100%;
    display: flex;
    justify-content: center;
    height:450px;
    background:rgba(238,242,254,1);
  }
  .cooperationBox_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .cooperationBox_header>div>span{
    font-size: 20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(51,51,51,1);
  }
  .cooperationBox_header>span{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(153,153,153,1);
    padding: 10px 0 40px 0;
  }
  .cooperationBox>div{
    width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 50px 0 80px 0;
  }
  .iconBox{
    display: flex;
    flex-wrap: wrap;
  }
  .iconBox img{
    width: 210px;
    height: 80px;
    margin: 30px 30px 0 0;
  }
  /deep/ .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 80px!important;
  }
  /deep/ .swiper-pagination-bullet{
    width:30px;
    height:2px;
    background:rgba(255,255,255,1);
    border-radius:1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/index/indexPage.vue